module.exports = __webpack_public_path__ + "img/icon-plants.19b765a8.svg";